import React, { useContext, useEffect, useState } from "react";
import Loading from "./components/Loading";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import "./styles.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import HomeGhana from "./pages/HomeGhana";
import HomeLiberia from "./pages/HomeLiberia";
import Career from "./pages/Careers";
import { CountryContext } from "./context/CountryContext";
import CaseStudies from "./pages/CaseStudies";
import Blog from "./pages/Blog";
import BlogDetails from "./pages/BlogDetails";
import Services from "./pages/Services";
import ContactUs from "./components/ContactUs";
import AboutUs from "./pages/AboutUs";
import LabServices from "./pages/LabServices";
import ServiceDetails from "./pages/ServiceDetails";
import ContactUsPage from "./pages/ContactUs";
import CaseStudyPDF from "./components/CaseStudyPdf";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookieConsent from "./components/CookieConsent";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  const [loading, setLoading] = useState(true);
  const { country } = useContext(CountryContext); // move hook to the top

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 800);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Loading />;
  }

  // Component to render the appropriate home page based on country
  const HomePage = () => {
    return country === "Liberia" ? <HomeLiberia /> : <HomeGhana />;
  };

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Nav />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/careers" element={<Career />} />
        <Route path="/caseStudies" element={<CaseStudies />} />
        <Route path="/caseStudies/:id" element={<CaseStudyPDF />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:id" element={<BlogDetails />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:id" element={<ServiceDetails />} />
        <Route path="/contactUs" element={<ContactUs />} />
        <Route path="/AboutUs" element={<AboutUs />} />
        <Route path="/LabServices" element={<LabServices />} />
        <Route path="/contactUsPage" element={<ContactUsPage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
      </Routes>
      <CookieConsent />
      <Footer />
    </BrowserRouter>
  );
}

export default App;
